import SocialShareLinks from './SocialShareLinks';

export default SocialShareLinks;
